// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.65 2.15H3.05C2.19 2.15 1.5 2.84 1.5 3.7V5.3C1.5 7.45 3.25 9.2 5.4 9.2C7.55 9.2 9.3 7.45 9.3 5.3V3.7C9.3 2.84 8.61 2.15 7.75 2.15H7.15',
  'M5.4 9.2V10.1C5.4 12.25 7.1 14 9.25 14C11.4 14 13.1 12.25 13.1 10.1V8.15',
  'M14.85 6.4C14.85 7.37 14.07 8.15 13.1 8.15C12.13 8.15 11.35 7.37 11.35 6.4C11.35 5.43 12.13 4.65 13.1 4.65C14.07 4.65 14.85 5.43 14.85 6.4Z',
];
